export default __webpack_public_path__ + "static/media/Bitmap_10.6308e34a.jpg";